import {
    IRef,
} from '../types';

import {
    useDefaultedRef,
} from 'tools/hooks';

import {
    ICreatePaymentDto,
} from 'entities/payments/requests/create-payment.dto';

export function useClientFieldsValuesInputRef() {
    return useDefaultedRef<IRef>({
        getValue(): ICreatePaymentDto['clientFieldsValues'] {
            return [];
        },
        validate(): boolean {
            return true;
        },
        setError(): void {
            return;
        },
    });
}
